// components/ui/VisibilityToggle.js
import React from "react";
import { GlobeAltIcon, LockClosedIcon } from "@heroicons/react/24/outline";

export default function VisibilityToggle({
  value,
  onChange,
  size = "md",
  className = "",
  showBothOptions = true,
  disabled = false,
}) {
  const sizeClasses = {
    sm: "px-3 py-1 text-xs gap-1",
    md: "px-4 py-1.5 text-sm gap-1",
    lg: "px-6 py-2 text-base gap-2",
  };

  const iconSizes = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  };

  const baseClasses = `flex items-center rounded-full border transition-colors ${sizeClasses[size]} disabled:opacity-50 disabled:cursor-not-allowed`;

  const getButtonClasses = (visibility) => {
    const isSelected = value === visibility;

    if (visibility === "public") {
      return isSelected
        ? "bg-primary border-border-primary-500 text-text-inverse shadow-sm"
        : "border-border-strong text-text-muted hover:bg-surface";
    } else {
      return isSelected
        ? "bg-surface-sunken border-border-strong text-text-secondary shadow-sm"
        : "border-border-strong text-text-muted hover:bg-surface";
    }
  };

  if (!showBothOptions) {
    // Single toggle mode - shows current state and toggles on click
    const isPublic = value === "public";
    const nextValue = isPublic ? "private" : "public";

    return (
      <button
        onClick={() => onChange(nextValue)}
        disabled={disabled}
        className={`${baseClasses} ${getButtonClasses(value)} ${className}`}
        title={`Switch to ${nextValue}`}
      >
        {isPublic ? (
          <GlobeAltIcon className={iconSizes[size]} />
        ) : (
          <LockClosedIcon className={iconSizes[size]} />
        )}
        {isPublic ? "Public" : "Private"}
      </button>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <button
        onClick={() => onChange("public")}
        disabled={disabled}
        className={`${baseClasses} ${getButtonClasses("public")}`}
      >
        <GlobeAltIcon className={iconSizes[size]} />
        Public
      </button>
      <button
        onClick={() => onChange("private")}
        disabled={disabled}
        className={`${baseClasses} ${getButtonClasses("private")}`}
      >
        <LockClosedIcon className={iconSizes[size]} />
        Private
      </button>
    </div>
  );
}
